import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SubModuleContent.style';
import { useSubModuleContext } from '../../context/sub-module';

const SubModuleContent = ({ children, className: classNameProp, noPadding, ...other }) => {
  const { isOpen } = useSubModuleContext();
  const className = clsx(styles.root, classNameProp, {
    [styles.noPadding]: noPadding,
    [styles.isClosed]: !isOpen,
    [styles.isOpen]: isOpen,
  });

  return (
    <div className={className} {...other}>
      {children}
    </div>
  );
};

SubModuleContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
};

SubModuleContent.defaultProps = {
  className: '',
  noPadding: false,
};

export default SubModuleContent;
